import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { Grid } from "@mui/material";
import { Box, color } from "@mui/system";
import { Typography } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import rightArrow from "assets/icons/arrow-right-landing.png";
import TextField from "common/formUI/textfield";
import { contactMail } from "services/DigitalSoultionServices";
import toast, { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
const UserForm = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const initialValues = {
    email: "",
    name: "",
    phone: "",
    news: "",
  };
  const validate = Yup.object({
    name: Yup.string()
      .required(t("required"))
      .max(35, t("digital-solution.form.name-error")),
    phone: Yup.string().matches(
      /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
      t("digital-solution.form.phone-error")
    ),
    email: Yup.string()
      .email(t("digital-solution.form.email-error"))
      .required(t("required")),
    news: Yup.string().required(t("required")),
  });
  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    const { name, email, phone, news } = values;
    const payload = {
      name,
      email,
      phone,
      news,
    };
    const result = await contactMail(payload);
    if (result.success) {
      resetForm();
      setLoading(false);
    } else {
    }
  };

  return (
    <>
      <Toaster />
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "25ch" },
        }}
        noValidate
        className="digital-solution-form padded-container12"
        autoComplete="off"
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          onSubmit={(values, { resetForm }) =>
            handleSubmit(values, { resetForm })
          }
        >
          {(formik) => {
            return (
              <Form>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="h3"
                      className="heading left-align padding-left-col"
                    >
                      {t("digital-solution.form.heading")}
                    </Typography>
                  </Grid>
                  <Grid item md={1} xs={12}></Grid>
                  <Grid item md={5} xs={12} marginBottom={10}>
                    <Box component="div" sx={{ width: "100%" }}>
                      <TextField
                        id="name"
                        label={t("digital-solution.form.name")}
                        name="name"
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        id="email"
                        label={t("digital-solution.form.email")}
                        name="email"
                        type="email"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        id="phone"
                        name="phone"
                        label={t("digital-solution.form.phone")}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                    marginBottom={10}
                  >
                    <TextField
                      id="text"
                      label={t("digital-solution.form.description")}
                      name="news"
                      type="text"
                      multiline
                      rows={5}
                      sx={{ backgroundColor: "#FFFFFF" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Box
                      component="div"
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "34%",
                      }}
                    >
                      <Box
                        component="div"
                        className="animated-link"
                        onClick={!loading && formik.handleSubmit}
                      >
                        <Typography variant="subtitle2" className="link-text">
                          {t("digital-solution.form.button-text")}
                        </Typography>
                        <Box className="right-arrow">
                          {loading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <img src={rightArrow} width="25px" />
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </>
  );
};

export default UserForm;
